<template>
  <!-- 项目申报 -->
  <div class="proReport">
    <div class="title f-r j-b">
      <span>项目申报</span>
      <span class="back" @click="back">返回申报列表</span>
    </div>
    <div class="report">
      <!-- 步骤条 -->
      <div class="apply-step">
        <el-steps :active="activeStep" align-center>
          <el-step
            :description="item.label"
            v-for="(item, index) in stepsList"
            :key="index"
            @click.native="onClickStep(index)"
          >
            <!-- <span slot="title">
                            <img :src="bindTitleIcon(index)" width="55" alt="" />
            </span>-->
            <div slot="icon">
              <!-- <img :src="(index === activeStep - 1) ? timeLineSelectIcon : timeLineNormalIcon" width="28"
              alt="" />-->
              <div :class="(index < activeStep - 1) ? 'stepCur' : ''">{{ index + 1 }}</div>
            </div>
          </el-step>
        </el-steps>
      </div>
      <!-- 申报表单 -->
      <div class="apply-form">
        <el-form
          v-show="activeStep == '1'"
          ref="form"
          :model="form"
          :rules="rules"
          label-width="165px"
          class="form-wrap"
          :disabled="disabled"
        >
          <div class="form-title">企业信息</div>
          <el-form-item label="申报单位名称：" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="申报单位地址：" prop="companyAddr">
            <el-input v-model="form.companyAddr" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="所属市、县（区）：" prop="regionValue">
            <el-cascader
              v-model="form.regionValue"
              :options="regionOptions"
              placeholder="请选择省/市/区县"
              :props="{ multiple: false }"
              clearable
              @change="changeRegion"
              style="width: 334px;"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="统一信用代码：" prop="companyCode">
            <el-input v-model="form.companyCode" placeholder="请输入" clearable />
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人：" prop="contact">
                <el-input v-model="form.contact" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：" prop="contactTel">
                <el-input v-model="form.contactTel" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-title">企业经营状况</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上年度主营业务收入：" prop="lastRevenue">
                <el-input v-model="form.lastRevenue" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上年度实现利润：" prop="lastProfit">
                <el-input v-model="form.lastProfit" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上年度上缴税金：" prop="lastTax">
                <el-input v-model="form.lastTax" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="本年度主营业务收入：" prop="currentRevenue">
                <el-input v-model="form.currentRevenue" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本年度实现利润：" prop="currentProfit">
                <el-input v-model="form.currentProfit" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="本年度上缴税金：" prop="currentTax">
                <el-input v-model="form.currentTax" placeholder="请输入" clearable class="w300" />
                <span>万元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="form-title">智能制造诊断评估</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="诊断评分：" prop="evaluateScore">
                <el-input v-model="form.evaluateScore" placeholder="请输入" clearable class="w150" />
                <span>分</span>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="f-r a-c">
              <el-upload
                v-if="!disabled"
                action="/service-center/api/v1/upload/file"
                :on-success="(val) => { handleAvatarSuccess(val, '1') }"
                :on-remove="(val) => { removeFile(val, '1') }"
                class="iploadInput f-r"
                :headers="headers"
                :before-upload="beforeAvatarUpload"
                :show-file-list="true"
                :limit="1"
                :disabled="disabled"
              >
                <div class="uploadBtn">
                  <i class="el-icon-upload2"></i>上传智能制造诊断评估报告
                </div>
              </el-upload>
              <div
                v-if="showFile1"
                class="downFile"
                @click="downloadFile(form.evaluate, form.evaluateName)"
              >
                {{
                form.evaluateName }}
              </div>
            </el-col>
          </el-row>
          <p v-if="!disabled">说明：请填写并上传智能制造诊断评估报告（上传PDF文件）</p>
          <p
            v-if="!disabled"
            style="margin-bottom:35px"
          >若未诊断，请先前往智能制造评估评价公共服务平台（访问地址：https://www.c3mep.cn/login ）进行诊断。</p>
          <div class="form-title">两化融合诊断评估</div>
          <el-row>
            <el-col :span="8">
              <el-form-item label="诊断评分：" prop="fusionScore">
                <el-input v-model="form.fusionScore" placeholder="请输入" clearable class="w150" />
                <span>分</span>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="f-r a-c">
              <el-upload
                v-if="!disabled"
                action="/service-center/api/v1/upload/file"
                :on-success="(val) => { handleAvatarSuccess(val, '2') }"
                :on-remove="(val) => { removeFile(val, '2') }"
                class="iploadInput f-r"
                :headers="headers"
                :before-upload="beforeAvatarUpload"
                :show-file-list="true"
                :limit="1"
                :disabled="disabled"
              >
                <div class="uploadBtn">
                  <i class="el-icon-upload2"></i>上传两化融合诊断评估报告
                </div>
              </el-upload>
              <div
                v-if="showFile2"
                class="downFile"
                @click="downloadFile(form.fusion, form.fusionName)"
              >
                {{
                form.fusionName }}
              </div>
            </el-col>
          </el-row>
          <p v-if="!disabled">说明：请填写并上传两化融合诊断评估报告（上传PDF文件）</p>
          <p
            v-if="!disabled"
            style="margin-bottom:35px"
          >若未诊断，请先前往两化融合评估诊断服务系统（访问地址：https://nxpg.cspiii.com/login ）进行诊断。</p>
        </el-form>
        <projectInfo v-show="activeStep == '2'" ref="secondStep" :projectId="projectId" />
        <serviceInfo v-show="activeStep == '3'" ref="thirdStep" :projectId="projectId" />
        <enterpriseInfo v-show="activeStep == '4'" ref="fourthStep" :projectId="projectId" />
        <h4 v-if="showDeclare">审核流程</h4>
        <div v-if="showDeclare" class="process">
          <div v-for="(item, index) in flowList" :key="index" class="f-r j-b a-c">
            <span>{{ index + 1 }}. {{ item.audit }}审核：{{ item.content }}</span>
            <span>{{ item.status | getStatus }} {{ item.auditTime }}</span>
          </div>
        </div>
        <div class="btnGroup f-r j-c a-c">
          <div class="form-pre" @click="back">关闭</div>
          <div v-show="activeStep > 1" class="form-pre" @click="activeStep--">上一步</div>
          <div v-show="activeStep < 4" class="form-next" @click="save()">下一步</div>
          <div v-show="activeStep == 4 && !disabled" class="form-next" @click="submit">提交</div>
          <div
            v-show="activeStep == 4 && !disabled"
            class="form-pre"
            style="background-color:#fff"
            @click="save()"
          >保存</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurrentInfo,
  saveCompanyInfo,
  getCompanyInfo,
  verifyFlowPath
} from "../../utils/interface";
import ningxia from "../../utils/ningxia";
import projectInfo from "./projectInfo.vue";
import serviceInfo from "./serviceInfo.vue";
import enterpriseInfo from "./enterpriseInfo.vue";
const form = () => {
  return {
    companyName: "", // 申报单位名称
    companyAddr: "", // 申报单位地址
    regionValue: "", // 所在省 市 县
    companyProvice: "", // 企业所在省
    companyCity: "", // 企业所在市
    companyArea: "", // 企业所在区
    companyCode: "", // 企业编码
    contact: "", // 联系人
    contactTel: "", // 联系人电话
    lastRevenue: "", // 上一年营收
    lastProfit: "", // 上一年利润
    lastTax: "", // 上一年交税
    currentRevenue: "", // 今年营收
    currentProfit: "", // 今年利润
    currentTax: "", // 今年交税
    evaluate: "", // 评估报告 文件上传后返回的地址
    evaluateScore: "", // 评估分数
    evaluateName: "", // 评估名称
    fusion: "", // 两化融合报告
    fusionScore: "", // 两化融合报告分数
    fusionName: "" // 两化融合报告名称
  };
};
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const rules = () => {
  return {
    companyName: [
      { required: true, message: "请输入申报单位名称", trigger: "blur" }
    ],
    companyAddr: [
      { required: true, message: "请输入申报单位地址", trigger: "blur" }
    ],
    regionValue: [
      { required: true, message: "请选择省/市/区", trigger: "change" }
    ],
    companyCode: [
      { required: true, message: "请输入统一信用代码", trigger: "blur" }
    ],
    contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
    contactTel: [
      { required: true, message: "请输入联系电话", trigger: "blur" }
    ],
    lastRevenue: [
      {
        required: true,
        validator: straight,
        message: "请输入上年度主营业务收入(0或正数)",
        trigger: "blur"
      }
    ],
    lastProfit: [
      {
        required: true,
        validator: straight,
        message: "请输入上年度实现利润(0或正数)",
        trigger: "blur"
      }
    ],
    lastTax: [
      {
        required: true,
        validator: straight,
        message: "请输入上年度上缴税金(0或正数)",
        trigger: "blur"
      }
    ],
    currentRevenue: [
      {
        required: true,
        validator: straight,
        message: "请输入本年度主营业务收入(0或正数)",
        trigger: "blur"
      }
    ],
    currentProfit: [
      {
        required: true,
        validator: straight,
        message: "请输入本年度实现利润(0或正数)",
        trigger: "blur"
      }
    ],
    currentTax: [
      {
        required: true,
        validator: straight,
        message: "请输入本年度上缴税金(0或正数)",
        trigger: "blur"
      }
    ],
    evaluateScore: [
      {
        required: true,
        validator: straight,
        message: "请输入诊断评分(0或正数)",
        trigger: "blur"
      }
    ],
    evaluate: [
      {
        required: true,
        validator: straight,
        message: "请上传智能制造诊断评估报告",
        trigger: "blur"
      }
    ],
    fusionScore: [
      {
        required: true,
        validator: straight,
        message: "请输入诊断评分(0或正数)",
        trigger: "blur"
      }
    ],
    fusion: [
      {
        required: true,
        validator: straight,
        message: "请上传两化融合诊断评估报告",
        trigger: "blur"
      }
    ],
  };
};
export default {
  name: "",
  components: { projectInfo, serviceInfo, enterpriseInfo },
  props: {},
  data() {
    return {
      headerBgUrl: require("../../assets/publicService/home/1.png"),
      stepsList: [
        { label: "申报企业基本信息" },
        { label: "申报项目基本信息" },
        { label: "平台服务商基本信息" },
        { label: "应用企业基本信息" }
      ],
      activeStep: 1,
      form: form(),
      rules: rules(),
      regionOptions: ningxia,
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      flowList: [], // 审核流程
      projectId: "", // 项目id
      disabled: false, // 根据status判断：INIT——待提交、REVIEW——审核中、REVIEW_PASS——审核通过、REJECT——驳回
      showFile1: false, // 详情或可修改状态时（INIT）为true展示
      showFile2: false,
      showDeclare: false // 是否展示审核流程，只有审核状态是通过、未通过、审核中的可以展示
    };
  },
  watch: {},
  filters: {
    getStatus(val) {
      if (val) {
        return val == "REJECT" ? "驳回" : "审核通过";
      } else {
        return;
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.projectId) {
      // console.log('第一步')
      // 如果是查看申报详情进来
      this.getCompanyInfo(this.$route.query.projectId);
    } else {
      // 点击申报进来
      this.getCurrentInfo();
    }
    if (
      this.$route.query.status == "REVIEW" ||
      this.$route.query.status == "REVIEW_PASS" ||
      this.$route.query.status == "REJECT"
    ) {
      this.showDeclare = true;
    }
  },
  methods: {
    back() {
      this.$router.push("/projectApply");
    },
    /* 获取当前登录企业的信息 */
    getCurrentInfo() {
      getCurrentInfo().then(res => {
        if (res && Object.keys(res).length > 0) {
          this.form.companyName = res.name;
          this.form.companyAddr = res.address;
          this.form.regionValue = res.areaList;
          this.form.companyProvice = res.areaList[0];
          this.form.companyCity = res.areaList[1];
          this.form.companyArea = res.areaList[2];
          this.form.companyCode = res.creditCode;
          this.form.contact = res.contact;
          this.form.contactTel = res.contactTel;
        } else {
          this.form = form();
        }
      });
    },
    onClickStep(index) {
      if (this.disabled) {
        // 如果当前为审核中或者审核通过的状态
        this.activeStep = index + 1;
      }
      // this.activeStep = index + 1
      // if (this.activeStep++ > 3) this.activeStep = 0;
    },
    /* 获取申报企业基本信息详情 */
    getCompanyInfo(projectId) {
      getCompanyInfo(projectId).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.getRegion();
          this.disabled =
            this.$route.query.status == "INIT" ||
            this.$route.query.status == "REJECT"
              ? false
              : true;
          this.showFile1 = true;
          this.showFile2 = true;
          this.verifyFlowPath(this.form.projectId);
        } else {
          this.form = form();
        }
      });
    },
    /* 下一步，保存 */
    save() {
      if (
        this.$route.query.status &&
        this.$route.query.status !== "INIT" &&
        this.$route.query.status !== "REJECT"
      ) {
        //如果该条状态 不为 申报中 或者 审核不通过，则点下一步时不用保存，即只能查看详情
        this.activeStep++;
      } else if (
        !this.$route.query.status ||
        this.$route.query.status == "INIT" ||
        this.$route.query.status == "REJECT"
      ) {
        // 如果该条状态为第一次填报 或者 申报中状态 或者 审核不通过状态，则点下一步时需要保存
        switch (this.activeStep) {
          case 1:
            this.firstSave();
            break;
          case 2:
            this.secondSave();
            break;
          case 3:
            this.thirdSave();
            break;
          case 4:
            this.fourthSave();
            break;
        }
      }
    },
    /* 第一步申报企业基本信息保存 */
    firstSave() {
      console.log("this.form=", this.form);
      if (this.form.evaluate==''){
        this.$message({
          message: "传智能制造诊断评估报告",
          type: "error"
        });
        return;
      }
      if (this.form.fusion==''){
        this.$message({
          message: "上传两化融合诊断评估报告",
          type: "error"
        });
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          // console.log('***', this.$route.query)
          saveCompanyInfo({
            policyUuid: this.$route.query.policyUuid,
            userUuid: this.$store.state.isUsermessage.uuid,
            ...this.form
          }).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.projectId = res.data.projectId;
              this.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    /* 第二步申报项目基本信息保存 */
    secondSave() {
      this.$refs.secondStep.save();
    },
    /* 第三步平台服务商基本信息 */
    thirdSave() {
      this.$refs.thirdStep.save();
    },
    /* 第四步应用企业基本信息 */
    fourthSave() {
      this.$refs.fourthStep.save("INIT");
    },
    /* 提交 */
    submit() {
      this.$refs.fourthStep.save("REVIEW");
    },
    /* 查看审核流程 */
    verifyFlowPath(projectId) {
      this.flowList = [];
      verifyFlowPath({
        projectId: projectId
      }).then(res => {
        if (res && res.length > 0) {
          res.map(el => {
            if (el.status == "REVIEW_PASS" || el.status == "REJECT") {
              this.flowList.push(el);
            }
          });
        }
      });
    },
    /* 改变省/区/市 */
    changeRegion(val) {
      // console.log(val)
      if (val) {
        this.form.companyProvice = val[0];
        this.form.companyCity = val[1];
        this.form.companyArea = val[2];
      } else {
        this.form.companyProvice = "";
        this.form.companyCity = "";
        this.form.companyArea = "";
      }
    },
    /* 回显省/区/市 */
    getRegion() {
      this.form.regionValue = [
        this.form.companyProvice,
        this.form.companyCity,
        this.form.companyArea
      ];
    },
    beforeAvatarUpload(file) {
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      let fileTypes = [".pdf", ".PDF"];
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      // console.log('fileTypeName:',fileTypeName,'file:',file)
      let fileIndex = fileTypes.indexOf(fileTypeName);
      if (fileIndex === -1) {
        this.$alert("只能上传PDF格式文件", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileIndex !== -1 && fileNameLength;
    },
    handleAvatarSuccess(res, type) {
      // console.log(res, type)
      if (res) {
        if (type == "1") {
          this.form.evaluateName = res.fileName;
          this.form.evaluate = res.url;
          this.showFile1 = false; // 详情原来如果有文件，在新文件上传后去替换掉
        } else {
          this.form.fusionName = res.fileName;
          this.form.fusion = res.url;
          this.showFile2 = false;
        }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        console.log("上传成功：", this.form);
      }
    },
    /* 移除文件 */
    removeFile(res, type) {
      if (type == "1") {
        this.form.evaluateName = "";
        this.form.evaluate = "";
      } else {
        this.form.fusionName = "";
        this.form.fusion = "";
      }
      // console.log('删除', this.form)
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.proReport {
  @import "../../assets/css/common.less";
  position: relative;
  background-color: #f4f4f4;
  padding: 0px 0 20px 0;
  overflow: hidden;

  .w150 {
    width: 150px;
  }

  .w300 {
    width: 300px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .title {
    color: @basic-colors;
    width: 1300px;
    margin: 10px auto 10px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: bold;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: @basic-colors;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .back {
      margin-right: 14px;
      cursor: pointer;
    }
  }

  .report {
    width: 1300px;
    min-height: 400px;
    background-color: #ffff;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;

    h4 {
      color: #535353;
      font-size: 14px;
      margin: 20px 0 20px 12px;
      position: relative;

      &::before {
        position: absolute;
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: -12px;
        top: 50%;
        transform: translateY(-50%);
        background-color: @basic-colors;
      }
    }

    .apply-step {
      margin: 20px 0px 20px;

      .stepCur {
        width: 36px;
        height: 36px;
        line-height: 36px;
        border-radius: 50%;
        color: #fff;
        background-color: @basic-colors;
      }
    }

    .apply-form {
      margin: 0 60px;
      min-height: 300px;
      padding-bottom: 30px;
      border-radius: 12px;

      .form-wrap {
        padding: 10px 20px;
        .bs();

        p {
          font-size: 14px;
          color: #888888;
          line-height: 1.7;
        }

        .form-title {
          font-size: 14px;
          font-weight: bold;
          margin: 0 0 30px 0px;
          position: relative;
          color: #535353;

          &::before {
            position: absolute;
            content: "";
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #000;
            top: 50%;
            left: -8px;
            transform: translateY(-50%);
          }
        }

        .iploadInput {
          display: inline-flex;
          justify-content: start;
          align-items: center;

          .uploadBtn {
            width: 200px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            box-sizing: border-box;
            font-size: 14px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #dcdfe6 !important;
          }
        }
      }

      .process {
        margin: 0 40px 40px;
        background-color: #fbfbfb;
        border-radius: 5px;
        padding: 20px;
      }

      .btnGroup {
        margin: 0 auto;

        .form-next,
        .form-pre,
        .form-save {
          width: 120px;
          height: 40px;
          .lh(40px);
          .bs();
          .bc();
          .br(4px);
          text-align: center;
          color: #fff;
          cursor: pointer;
          margin: 0 5px;
        }

        .form-pre {
          color: @basic-colors;
          border: 1px solid #2d50a1;
          .bc(15%);
        }

        .form-save {
          background-color: #909399;
          border-color: #909399;
        }
      }
    }
  }

  /* 步骤条样式 */
  /deep/ .el-step__icon.is-text.is-finish {
    border: 2px solid @basic-colors;
  }

  /deep/ .el-step__head.is-finish {
    border-color: @basic-colors;
  }

  /deep/ .el-step__title {
    font-size: 16px;
    line-height: 38px;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    top: -60px;
  }

  /deep/ .el-step.is-center .el-step__description {
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
    color: @basic-colors;
    cursor: pointer;
  }

  /deep/ .el-step__icon {
    width: 36px;
    height: 36px;
    color: @basic-colors;
    cursor: pointer;
  }

  /deep/ .el-step.is-horizontal .el-step__line {
    top: 18px;
  }
  /deep/ .el-step__head.is-process {
    color: #c0c4cc;
    border-color: #c0c4cc;
  }
  /* 上传进度条样式 */
  /deep/ .el-upload-list {
    display: inline-block;
    margin-left: 20px;
  }

  /deep/ .el-upload-list__item:first-child {
    margin-top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projectApply/projectReport.vue